export default "__VITE_ASSET__Chda2FMQ__"